import React, { useState } from 'react';
import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import Button from "@/components/button";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {useTranslation } from '@/imports-files/common/common';
import ButtonStyle from "@/styles/components/button/_index.module.scss";
import Modal from "@/components/common-modal/modal";
import { InfoModalStyle } from "@/imports-files/components/common-modal/common-modal";


// Custom Next Arrow Component
const NextArrow = (props) => {
  const { t } = useTranslation(); // Translation hook
  const { className, onClick } = props;

  return (
    <div className={className}>
      <Button buttonstyle={ButtonStyle.primarybtn} type="button" onClick={onClick}>{t('button:next')}</Button>
    </div>
  );
};

export function BrandGuide({setBrandModal}) 
{
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [heading, setHeading] = useState(t('modal:info:brand_guide:page'));

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    fade: true,
    nextArrow: <NextArrow />,
    afterChange: (current) => {
      if (current === 0) {
        setHeading(t('modal:info:brand_guide:page'));
      } else if (current === 1) {
        setHeading(t('modal:info:brand_guide:email'));
      }
    },
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };


  return (

    <Modal
    type="info"
      closeModal={() => setBrandModal(false)}
      className={`brandmodal`}
      heading={heading}
      largeWidth = {true}
      innerContent={
        <>
        <Slider {...settings}>
          <div>
              <img src={`/images/pages/brand/language/${currentLanguage}.png`} alt={`${currentLanguage}`} />
          </div>
          <div className={`mt0`}>
              <img src={`/images/pages/brand/language/${currentLanguage}1.png`} alt={`${currentLanguage}`} />
          </div>
        </Slider>
        <div className={`${InfoModalStyle.Modal__Container__ButtonSection} PositionRelative`}>
          <div className={PageStyle.SetupPopup__SubmitSectionAutomation}>
            <Button buttonstyle={ButtonStyle.primarybtn} type="button" onClick={() => setBrandModal(false)}>
              {t('button:got_it')}
            </Button>
          </div>
        </div>
      </>
      }
    />
  ) 
}
